import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { V2Color } from 'src/app/v2-components/models/v2-colors.model';

@Component({
  selector: 'v2-unavailable-item-chip',
  template: `
    <v2-chip size="small" [color]="getChipColor()" id="the-chip">
      <v2-label-small-text color="white" textAlign="center">
        {{ inStock ? 'U/A' : ('Menu.Items.SoldOut' | translate | uppercase) }}
      </v2-label-small-text>
    </v2-chip>
  `,
  styles: [
    `
      #the-chip {
        padding: 2px 12px;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class V2UnavailableItemChip {
  @Input() color?: V2Color;
  @Input() isDisabled!: boolean;
  @Input() inStock!: boolean;

  getChipColor(): V2Color {
    if (this.color) {
      return this.color;
    }

    return this.isDisabled ? 'inactive-grey' : 'medium-grey';
  }
}
